// 多语言配置主入口文件
import { common } from './common.js';
import { menu } from './menu.js';
import { dashboard } from './dashboard.js';
import { customer } from './customer.js';
import { login } from './login.js';
import { pageTitle } from './pageTitle.js';
import { order } from './order.js';
import { marketing } from './marketing.js';
import { finance } from './finance.js';
import { business } from './business.js';
import { merchandise } from './merchandise.js';
import { miniprogram } from './miniprogram.js';
import { article } from './article.js';
import { referralRules } from './referralRules.js';
import { withdrawalList } from './withdrawalList.js';
import { financialStatistics } from './financialStatistics.js';
import { turnToIntroduce } from './turnToIntroduce.js';
import { videoManage } from './videoManage.js';
import { addedServices } from './addedServices.js';
import { agency } from './agency.js';

// 全局多语言配置
export const i18nConfig = {
  'zh-CN': {
    common: common['zh-CN'],
    menu: menu['zh-CN'],
    dashboard: dashboard['zh-CN'],
    customer: customer['zh-CN'],
    login: login['zh-CN'],
    pageTitle: pageTitle['zh-CN'],
    order: order['zh-CN'],
    marketing: marketing['zh-CN'],
    finance: finance['zh-CN'],
    business: business['zh-CN'],
    merchandise: merchandise['zh-CN'],
    miniprogram: miniprogram['zh-CN'],
    article: article['zh-CN'],
    referralRules: referralRules['zh-CN'],
    withdrawalList: withdrawalList['zh-CN'],
    financialStatistics: financialStatistics['zh-CN'],
    turnToIntroduce: turnToIntroduce['zh-CN'],
    videoManage: videoManage['zh-CN'],
    addedServices: addedServices['zh-CN'],
    agency: agency['zh-CN']
  },
  'zh-TW': {
    common: common['zh-TW'],
    menu: menu['zh-TW'],
    dashboard: dashboard['zh-TW'],
    customer: customer['zh-TW'],
    login: login['zh-TW'],
    pageTitle: pageTitle['zh-TW'],
    order: order['zh-TW'],
    marketing: marketing['zh-TW'],
    finance: finance['zh-TW'],
    business: business['zh-TW'],
    merchandise: merchandise['zh-TW'],
    miniprogram: miniprogram['zh-TW'],
    article: article['zh-TW'],
    referralRules: referralRules['zh-TW'],
    withdrawalList: withdrawalList['zh-TW'],
    financialStatistics: financialStatistics['zh-TW'],
    turnToIntroduce: turnToIntroduce['zh-TW'],
    videoManage: videoManage['zh-TW'],
    addedServices: addedServices['zh-TW'],
    agency: agency['zh-TW']
  },
  'en': {
    common: common['en'],
    menu: menu['en'],
    dashboard: dashboard['en'],
    customer: customer['en'],
    login: login['en'],
    pageTitle: pageTitle['en'],
    order: order['en'],
    marketing: marketing['en'],
    finance: finance['en'],
    business: business['en'],
    merchandise: merchandise['en'],
    miniprogram: miniprogram['en'],
    article: article['en'],
    referralRules: referralRules['en'],
    withdrawalList: withdrawalList['en'],
    financialStatistics: financialStatistics['en'],
    turnToIntroduce: turnToIntroduce['en'],
    videoManage: videoManage['en'],
    addedServices: addedServices['en'],
    agency: agency['en']
  }
};

// 获取指定语言的文本
export function getText(language, category, key) {
  try {
    return i18nConfig[language]?.[category]?.[key] || key;
  } catch (error) {
    console.warn('获取多语言文本失败:', error);
    return key;
  }
}

// 获取当前语言的文本
export function getCurrentText(category, key) {
  const currentLanguage = localStorage.getItem('language') || 'zh-TW';
  return getText(currentLanguage, category, key);
}

// 语言切换工具类
export class I18nManager {
  constructor() {
    this.currentLanguage = localStorage.getItem('language') || 'zh-TW';
    this.listeners = [];
  }

  // 设置语言
  setLanguage(language) {
    if (this.currentLanguage !== language && i18nConfig[language]) {
      this.currentLanguage = language;
      localStorage.setItem('language', language);
      this.notifyListeners();
    }
  }

  // 获取当前语言
  getCurrentLanguage() {
    return this.currentLanguage;
  }

  // 添加监听器
  addListener(listener) {
    if (typeof listener === 'function' && !this.listeners.includes(listener)) {
      this.listeners.push(listener);
    }
  }

  // 移除监听器
  removeListener(listener) {
    const index = this.listeners.indexOf(listener);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }

  // 通知所有监听器
  notifyListeners() {
    this.listeners.forEach(listener => {
      try {
        listener(this.currentLanguage);
      } catch (error) {
        console.warn('多语言监听器执行失败:', error);
      }
    });
  }

  // 获取文本
  getText(category, key, language = null) {
    const targetLanguage = language || this.currentLanguage;
    return getText(targetLanguage, category, key);
  }
}

// 创建全局实例
export const i18nManager = new I18nManager(); 